import { Category, CategoryType } from '../api/types';
import { theme } from '../theme';
import { Icon, categoryIconName } from './Icon';

interface Props {
  categories: Category[];
  value: string | null;
  onChange: (name: string) => void;
}

export function CategoryPicker({ categories, value, onChange }: Props) {
  const sorted = [...categories].sort((a, b) => a.sort_order - b.sort_order);
  const expenses = sorted.filter((c) => c.type === 'Расход');
  const incomes  = sorted.filter((c) => c.type === 'Доход');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
      <Group title="Расходы" items={expenses} value={value} onChange={onChange} />
      <Group title="Доходы"  items={incomes}  value={value} onChange={onChange} />
    </div>
  );
}

function Group({
  title,
  items,
  value,
  onChange,
}: {
  title: string;
  items: Category[];
  value: string | null;
  onChange: (name: string) => void;
}) {
  if (items.length === 0) return null;
  return (
    <div>
      <div
        style={{
          fontSize: 12,
          letterSpacing: 1.4,
          textTransform: 'uppercase',
          color: theme.colors.sub,
          marginBottom: 8,
        }}
      >
        {title}
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(96px, 1fr))',
          gap: 8,
        }}
      >
        {items.map((c) => (
          <CategoryButton key={c.name} cat={c} active={value === c.name} onClick={() => onChange(c.name)} />
        ))}
      </div>
    </div>
  );
}

function CategoryButton({
  cat,
  active,
  onClick,
}: {
  cat: Category;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      onClick={onClick}
      aria-pressed={active}
      style={{
        padding: '10px 8px',
        borderRadius: theme.radius.md,
        background: active ? cat.color : theme.colors.card,
        color: active ? theme.colors.paper : theme.colors.ink,
        border: `1px solid ${active ? cat.color : theme.colors.line}`,
        cursor: 'pointer',
        fontFamily: theme.font,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 4,
        minHeight: 78,
        transition: 'background .15s, border-color .15s',
      }}
    >
      <Icon name={categoryIconName(cat)} size={22} />
      <div style={{ fontSize: 11, lineHeight: 1.2 }}>{cat.name}</div>
    </button>
  );
}

export function categoryType(name: string, all: Category[]): CategoryType | null {
  const c = all.find((x) => x.name === name);
  return c ? c.type : null;
}
